<template>
<div class="chapter">
<div class="inner_page">
<h2 class="h2"><a id="page_vii"></a>Contents</h2>
<p class="toc"><span href="#/html/cover" title="Link target outside of Sample"><em>Cover</em></span></p>
<p class="toc"><span href="#/html/9780226389387_03_cpy" title="Link target outside of Sample"><em>Copyright</em></span></p>
<p class="toc"><a href="#/html/9780226389387_07_ack#ack"><em>Acknowledgments</em></a></p>
<p class="toc"><a href="#/html/9780226389387_08_int#int"><em>Introduction</em></a></p>
<p class="toc-chapt"><a href="#/html/9780226389387_09_ch1#ch1">1   Dewey’s Parting Words</a></p>
<p class="toc-chap"><span href="#/html/9780226389387_10_ch2#ch2" title="Link target outside of Sample">2   Trafficking in Truth</span></p>
<p class="toc-chap"><span href="#/html/9780226389387_11_ch3#ch3" title="Link target outside of Sample">3   Preconditions of Education</span></p>
<p class="toc-chap"><span href="#/html/9780226389387_12_ch4#ch4" title="Link target outside of Sample">4   Unifying Essence and Existence</span></p>
<p class="toc-chap"><span href="#/html/9780226389387_13_ch5#ch5" title="Link target outside of Sample">5   Making Subjects Matter</span></p>
<p class="toc-chap"><span href="#/html/9780226389387_14_ch6#ch6" title="Link target outside of Sample">6   In Pursuit of Perfection</span></p>
<p class="toc-chap"><span href="#/html/9780226389387_15_ch7#ch7" title="Link target outside of Sample">7   Education as a Moral Enterprise</span></p>
<p class="toct"><span href="#/html/9780226389387_16_fur#fur" title="Link target outside of Sample"><em>Further Reading</em></span></p>
<p class="toc"><span href="#/html/9780226389387_17_bib#bib" title="Link target outside of Sample"><em>Bibliography</em></span></p>
<p class="toc"><span href="#/html/9780226389387_18_ind#ind" title="Link target outside of Sample"><em>Index</em></span><a id="page_viii"></a></p>
</div>
</div>
</template>
<script>

export default {
  name: 'chapter',
  data() {
    return {}
    },
      components: {
    }
  }
</script>



// WEBPACK FOOTER //
// 9780226389387_06_toc.vue?e941a360